import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _DocumentHeaderByProcess } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { _DocumentFactory, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { DocumentViewer } from "../../../../theme/Component/DocumentViewer";


interface Props {
    idProcess: number;
    year: number;
}

export const DocumentHeaderByProcess = ({ idProcess, year }: Props) => {

    const docbyprocces = useDataBean(_DocumentHeaderByProcess);
    const _documentos = useDataBean(_DocumentFactory);
    const single = Singleton.getInstance();
    const [docs, setDocs] = useState<any>([]);
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idProcess, year])
    useEffect(() => {
        if (modal.view) {
            verDocumentos();
        }
    }, [modal.view]);
    const getLista = () => {

        docbyprocces.instance.getDocumentHeaderByProcess(idProcess, year).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp.reverse())
                    //console.log(resp)
                }
            }
        )

    }
    const verDocumentos = () => {

        if (docbyprocces.bean.IDDocument) {
            _documentos.instance.getPdfAccountantDocument(docbyprocces.bean.IDDocument, null, docbyprocces.bean.Since, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    // setregistro({ ...registro, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const create = () => {
        docbyprocces.setBean({
            // IDMacroProcess: IDMacroProcess
        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        docbyprocces.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Estado', property: 'DocumentStateName', visible: true },
        { title: 'Fecha Documento', property: 'Since', visible: true },


    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Ver Documento', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <label>Documentos del Proceso</label>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={docbyprocces.setBean} listButtons={listaBotones()}></BasicTable>
                <Modal modal={modal} updateModal={setModal}>
                    <div className="row">
                        <div className="col-md-12">
                            <DocumentViewer
                                list={docs}
                                IDDocument={docbyprocces.bean.IDDocument}
                                Since={docbyprocces.bean.Since}
                            />
                        </div>
                    </div>
                </Modal>

                {/* <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm> */}
            </div>

        </div>
    )
}